<template>
  <div>
    <v-card height="100%" outlined max-width="400" @click="$emit('click')">
      <v-img
        v-if="this.selector"
        :src="
          this.product.thumbnail_url ||
          this.product.picture_url ||
          'https://skotfashion.com/wp-content/uploads/2018/02/placeholder.jpg'
        "
        width="100%"
        aspect-ratio=".85"
        cover
      >
        <v-card-title
          v-show="select_ids && select_ids.includes(this.product.product_id)"
        >
          <v-icon color="success" size="60">
            mdi-checkbox-marked-circle
          </v-icon>
        </v-card-title>
      </v-img>
      <v-hover v-model="hover" v-else>
        <div v-if="!hover">
          <v-img
            :src="
              this.product.thumbnail_url ||
              this.product.picture_url ||
              'https://skotfashion.com/wp-content/uploads/2018/02/placeholder.jpg'
            "
            width="100%"
            aspect-ratio=".85"
            cover
          >
            <v-card-title
              v-show="
                select_ids && select_ids.includes(this.product.product_id)
              "
            >
              <v-icon color="success" size="60">
                mdi-checkbox-marked-circle
              </v-icon>
            </v-card-title>
          </v-img>
        </div>
        <div v-else>
          <div v-if="product.alternate">
            <v-img
              v-if="product.alternate.length > 0"
              :src="this.product.alternate[1] || this.product.alternate[0]"
              width="100%"
              aspect-ratio="0.85"
              cover
            >
              <v-card-title
                v-show="
                  select_ids && select_ids.includes(this.product.product_id)
                "
              >
                <v-icon color="success" size="60">
                  mdi-checkbox-marked-circle
                </v-icon>
              </v-card-title>
            </v-img>
            <v-img
              v-else
              :src="
                this.product.thumbnail_url ||
                this.product.picture_url ||
                'https://skotfashion.com/wp-content/uploads/2018/02/placeholder.jpg'
              "
              width="100%"
              aspect-ratio=".85"
              cover
            >
              <v-card-title
                v-show="
                  select_ids && select_ids.includes(this.product.product_id)
                "
              >
                <v-icon color="success" size="60">
                  mdi-checkbox-marked-circle
                </v-icon>
              </v-card-title>
            </v-img>
          </div>
          <div v-else>
            <v-img
              :src="
                this.product.thumbnail_url ||
                this.product.picture_url ||
                'https://skotfashion.com/wp-content/uploads/2018/02/placeholder.jpg'
              "
              width="100%"
              aspect-ratio=".85"
              cover
            >
              <v-card-title
                v-show="
                  select_ids && select_ids.includes(this.product.product_id)
                "
              >
                <v-icon color="success" size="60">
                  mdi-checkbox-marked-circle
                </v-icon>
              </v-card-title>
            </v-img>
          </div>
        </div>
      </v-hover>

      <div v-if="!product.name && !product.categories && !product.price">
        <v-row>
          <v-col>
            <v-card-text>
              <v-list-item>
                <v-list-item-content></v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <v-card-title class="pb-0 pl-4 pt-1 d-inline-block prod_name">
          <h5
            class="font-weight-reguler text-truncate"
            style="max-width: 171px"
          >
            {{ product.name }}
          </h5>
        </v-card-title>

        <v-card-text class="pb-0">
          <v-list-item class="pl-0">
            <v-list-item-content class="pt-0 pb-0">
              <v-row align="center" dense>
                <!--v-col cols='12' sm='12'>
                    <div class="#3a3232--text">
                      <v-icon color="#1141ce" size="20" class="mr-1">mdi-cart </v-icon>
                      {{ product.brand }}
                    </div>
              </v-col-->
                <v-col
                  v-show="product.category"
                  cols="12"
                  sm="12"
                  class="pt-0 mt-0"
                >
                  <v-list-item-subtitle class="ma-0 mb-0">
                    <h4 class="font-weight-reguler black--text">
                      <v-icon color="#1141ce" size="20" class="mr-1"
                        >mdi-hanger </v-icon
                      >{{
                        product.categories[product.categories.length - 1] || "-"
                      }}
                    </h4>
                  </v-list-item-subtitle>
                </v-col>
                <v-col cols="12" sm="12" v-show="product.price">
                  <v-row
                    align="center"
                    dense
                    :class="!product.price_old ? 'mb-2' : ''"
                  >
                    <v-col
                      cols="12"
                      :sm="product.price_old ? '6' : 'auto'"
                      class="pr-0 mr-0 mx-0"
                    >
                      <span
                        >Price
                        <span class="font-weight-bold #000000d9--text ml-1"
                          >{{ product.price }}€
                        </span>
                      </span>
                    </v-col>
                    <v-col
                      v-if="product.price_old"
                      cols="12"
                      sm="6"
                      class="pr-0 mr-0"
                    >
                      <span
                        >Old Pr.

                        <strike
                          class="font-weight-bold subtitle-2 #000000d9--text ml-1"
                        >
                          {{ numberWithSpaces(product.price_old) }}€
                        </strike>
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "ProductCard",
  components: {},
  data: () => {
    return {
      sheet: false,
      show: false,
      hover: false,
    };
  },
  props: {
    categorie: null,
    search: null,
    product: null,
    select_ids: null,
    selector: null,
  },
  computed: {},
  methods: {
    pictureSwitcher(state) {
      if (state) {
        this.url_img = this.product.picture_url;
      }
      if (state == false && this.product.alternate[0] != null) {
        this.url_img = this.product.alternate[0];
      }
    },
    numberWithSpaces(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }
      return 0;
    },
  },
};
</script>

<style scoped>
.text-selected {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  font-size: 2rem;
  font-weight: 800;
}
.main_card {
  border-radius: 1rem;
}
.picture {
  width: 100%;
}
.selected {
  border: solid red 3px;
}
.prod_name {
  max-width: 280px;
  margin-left: -2px;
}
@media only screen and (max-width: 500px) {
  .prod_name {
    max-width: 175px;
    margin-left: -8px;
  }
}
</style>
